// extracted by mini-css-extract-plugin
export default {"skipdatecontain":"wU","skip_info":"xU","skipped":"yU","modify_order":"zU","cancel_subscription_btn":"AU","byb":"BU","modify_order_outer":"CU","byb_edit_btn":"EU","modify_order_item":"FU","cancel_copy_wrapper":"GU","cancelled_copy":"HU"};
    if(module.hot) {
      // 1715276859582
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  